var map = {
	"./buddy/videos/aboutus.mp4": 250,
	"./buddy/videos/commercial.mp4": 1301,
	"./buddy/videos/fiction.mp4": 1798,
	"./buddy/videos/image.mp4": 7792,
	"./buddy/videos/main.mp4": 2881,
	"./buddy/videos/showreel.mp4": 2056,
	"./camcore/logo.svg": 1546,
	"./camcore/videos/aboutus.mp4": 4514,
	"./camcore/videos/commercial.mp4": 5972,
	"./camcore/videos/fiction.mp4": 9198,
	"./camcore/videos/image.mp4": 5786,
	"./camcore/videos/main.mp4": 2262,
	"./camcore/videos/showreel.mp4": 1152,
	"./cancelcancer/logo.svg": 143,
	"./cancelcancer/supporter.png": 2232,
	"./cancelcancer/supporterm.png": 582,
	"./cancelcancer/videos/main.mp4": 2861,
	"./filmpiraten/logo.svg": 3241,
	"./filmpiraten/videos/aboutus.mp4": 7346,
	"./filmpiraten/videos/commercial.mp4": 3063,
	"./filmpiraten/videos/fiction.mp4": 9564,
	"./filmpiraten/videos/image.mp4": 6618,
	"./filmpiraten/videos/main.mp4": 7515,
	"./filmpiraten/videos/showreel.mp4": 4704,
	"./images/awards/cannes.png": 7656,
	"./images/awards/deutscherkamerapreis.png": 4293,
	"./images/awards/jupiter.png": 6421,
	"./images/awards/lafa.png": 5818,
	"./images/awards/selb.png": 1552,
	"./images/awards/shokingshorts.png": 837,
	"./images/berlin.svg": 2008,
	"./images/bielefeld.svg": 3187,
	"./images/bremerhaven.svg": 631,
	"./images/de.svg": 2170,
	"./images/en.svg": 7456,
	"./images/leaves_left.svg": 7129,
	"./images/leaves_right.svg": 5239,
	"./images/nrw.svg": 7783,
	"./variables.scss": 995,
	"./videos/aolenberg.mp4": 9694,
	"./videos/astarczyk.mp4": 745,
	"./videos/ayalcin.mp4": 1121,
	"./videos/bdevletli.mp4": 7774,
	"./videos/bleisten.mp4": 705,
	"./videos/bniemeier.mp4": 1714,
	"./videos/dlittau.mp4": 2150,
	"./videos/dmanns.mp4": 1620,
	"./videos/efrantzen.mp4": 8543,
	"./videos/jctvrtnicek.mp4": 5287,
	"./videos/jnickel.mp4": 6196,
	"./videos/liolenberg.mp4": 5470,
	"./videos/lolenberg.mp4": 5999,
	"./videos/mmohnke.mp4": 775,
	"./videos/nretzlaff.mp4": 5819,
	"./videos/sdukkardt.mp4": 5879,
	"./videos/skeilbach.mp4": 4826
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;